module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (12).52e8b288.jpg";